/**
 * Column configuration for Contacts/Leads table
 * Used by TableContactList component for header rendering
 */

// Base columns shown for both Contacts and Leads
export const BASE_COLUMNS = [
  { key: 'id', label: 'ID', sortable: false },
  { key: 'firstName', label: 'First Name', sortable: false },
  { key: 'lastName', label: 'Last Name', sortable: false },
  { key: 'email', label: 'Email', sortable: false },
  { key: 'primaryPhone', label: 'Primary Phone', sortable: false },
  { key: 'createdAt', label: 'Created At', field: 'createdAt', sortable: true },
]

// Additional columns only shown for Contacts (isContacts=true)
export const CONTACTS_ONLY_COLUMNS = [
  { key: 'dateOfBirth', label: 'Date of Birth', sortable: false },
  { key: 'enrollmentDate', label: 'Date Enrolled', field: 'enrollmentDate', sortable: true },
  { key: 'canceledDate', label: 'Cancelled Date', sortable: false },
  { key: 'nextPayment', label: 'Next Payment', field: 'nextPayment.dueDate', sortable: true },
  { key: 'amount', label: 'Amount', sortable: false },
  { key: 'totalDebtEnrolled', label: 'Total Debt Enrolled', sortable: false },
  { key: 'programLength', label: 'Program Length', sortable: false },
  { key: 'welcomeCall', label: 'Welcome Call', field: 'welcomeCallCompleted', sortable: true },
  { key: 'planStatus', label: 'Plan Status', field: 'plan.status', sortable: true },
]

// Lead Source column - shown for both Contacts and Leads
export const LEAD_SOURCE_COLUMN = [
  { key: 'acquisitionSource', label: 'Lead Source', sortable: false },
]

// Lead Status column - shown for Leads only (sub-status / disposition)
export const DISPOSITION_COLUMN = [
  { key: 'disposition', label: 'Lead Status', sortable: false },
]

export const DEBT_AMOUNT_COLUMN = [
  { key: 'debtAmount', label: 'Debt Amount', sortable: false },
]

// End columns - Status and Creator
export const END_COLUMNS = [
  { key: 'status', label: 'Status', sortable: false },
  { key: 'creator', label: 'Creator', field: 'creator.firstName', sortable: true },
]

// Assignees column only for Contacts
export const ASSIGNEES_COLUMN = [
  { key: 'assignees', label: 'Assignees', sortable: false },
]

/**
 * Get all columns based on isContacts mode
 * @param {boolean} isContacts - Whether showing Contacts (true) or Leads (false)
 * @returns {Array} Array of column configurations
 */
export const getColumns = (isContacts, { showDebtAmount = false } = {}) => {
  const columns = [...BASE_COLUMNS]

  if (isContacts) {
    columns.push(...CONTACTS_ONLY_COLUMNS)
  }

  if (!isContacts) {
    columns.push(...DISPOSITION_COLUMN)
    if (showDebtAmount) {
      columns.push(...DEBT_AMOUNT_COLUMN)
    }
  }

  columns.push(...LEAD_SOURCE_COLUMN)
  columns.push(...END_COLUMNS)

  if (isContacts) {
    columns.push(...ASSIGNEES_COLUMN)
  }

  return columns
}
